module.exports = __webpack_public_path__ + "static/media/card-image-liquidecora.42b40974.jpg";